<rav-modal [modalId]="'authentication'" modalTitle="Authenticate to continue">
  <rav-form
    (formSubmit)="authenticate($event)"
    [formGroup]="authenticateFormGroup"
    [fields]="[{ name: 'password' }]"
    [isButtonDisabled]="isAuthenticating"
    buttonText="{{ isAuthenticating ? 'Authenticating...' : 'Authenticate' }}"
  >
  </rav-form>
</rav-modal>
